const {
	identity
} = require("lodash");

// mostrar senha
window.mudar = function () {
	var password = document.getElementById('password');
	var eyes = document.getElementById('eyes');
	if (password.type === "password") {
		password.type = "text";
		eyes.classList.add("fa-eye");
		eyes.classList.remove("fa-eye-slash");
	} else {
		password.type = "password";
		eyes.classList.remove("fa-eye");
		eyes.classList.add("fa-eye-slash");
	}
}
window.mostrarSenha = function () {
	var passwordCadastro = document.getElementById('passwordCadastro');
	var eyesCadastro = document.getElementById('eyesCadastro');
	if (passwordCadastro.type === "password") {
		passwordCadastro.type = "text";
		eyesCadastro.classList.add("fa-eye");
		eyesCadastro.classList.remove("fa-eye-slash");
	} else {
		passwordCadastro.type = "password";
		eyesCadastro.classList.remove("fa-eye");
		eyesCadastro.classList.add("fa-eye-slash");
	}
}
window.mostrarSenha2 = function () {
	var passwordCadastro = document.getElementById('passwordCadastro2');
	var eyesCadastro = document.getElementById('eyesCadastro2');
	if (passwordCadastro.type === "password") {
		passwordCadastro.type = "text";
		eyesCadastro.classList.add("fa-eye");
		eyesCadastro.classList.remove("fa-eye-slash");
	} else {
		passwordCadastro.type = "password";
		eyesCadastro.classList.remove("fa-eye");
		eyesCadastro.classList.add("fa-eye-slash");
	}
}
// minha conta senha
window.minhaconta1 = function () {
	var password = document.getElementById('password_conta1');
	var eyes = document.getElementById('eyes_conta1');
	if (password.type === "password") {
		password.type = "text";
		eyes.classList.add("fa-eye");
		eyes.classList.remove("fa-eye-slash");
	} else {
		password.type = "password";
		eyes.classList.remove("fa-eye");
		eyes.classList.add("fa-eye-slash");
	}
}
window.minhaconta2 = function () {
	var password = document.getElementById('password_conta2');
	var eyes = document.getElementById('eyes_conta2');
	if (password.type === "password") {
		password.type = "text";
		eyes.classList.add("fa-eye");
		eyes.classList.remove("fa-eye-slash");
	} else {
		password.type = "password";
		eyes.classList.remove("fa-eye");
		eyes.classList.add("fa-eye-slash");
	}
}
window.minhaconta3 = function () {
	var password = document.getElementById('password_conta3');
	var eyes = document.getElementById('eyes_conta3');
	if (password.type === "password") {
		password.type = "text";
		eyes.classList.add("fa-eye");
		eyes.classList.remove("fa-eye-slash");
	} else {
		password.type = "password";
		eyes.classList.remove("fa-eye");
		eyes.classList.add("fa-eye-slash");
	}
}

// abre menu
window.abreMenu = function () {
	document.getElementById("menuMobile").style.display = "flex";
}
window.fechaMenu = function () {
	document.getElementById("menuMobile").style.display = "none";
}

// fechar erro
window.fechaErro = function () {
	document.getElementById("blocoErro").style.display = "none";
}

// envia informações pro modal
window.enviaDados = function (qrcode, method, boleto) {
	var p = document.getElementById('pModal');
	var pI = document.getElementById('pInicio');
	var img = document.getElementById('imgModal');
	var a = document.getElementById('aModal');
	var button = document.getElementById('buttonModal');
	var html = document.getElementById('html');
	html.style.overflow = 'hidden';
	if (method) {
		if (method == 0){
				pI.innerHTML = 'Seu pagamento foi realizado via cartão de crédito, seu contrato será liberado assim que o localizarmos. <br><br> Caso não identifique o desconto, entre em contato com o nosso time!';
				p.innerHTML = '';
				img.innerHTML = '';
				button.style.display = 'none'
		}else {
			p.innerHTML = " "
			pI.innerHTML = " "
			img.innerHTML = '<p class="pModal">Ops, algo deu errado com o seu pagamento, entre em contato com o nosso time ou refaça o contrato.</p>';
			button.style.display = 'none';
		}
		if (method == 3) {
			if (qrcode) {
				pI.innerHTML = 'Percebemos que você ainda não realizou o pagamento de seu contrato, aqui estão os dados importantes para o pagamento.';
				p.innerHTML = 'Seu QRCode pix';
				img.innerHTML = '<img src="data:image/jpeg;base64,' + qrcode + '"/>';
				button.style.display = 'none';
			} else {
				p.innerHTML = " "
				pI.innerHTML = " "
				img.innerHTML = '<p class="pModal">Ops, algo deu errado com o seu pagamento, entre em contato com o nosso time ou refaça o contrato.</p>';
				button.style.display = 'none';
			}
		} else if (method == 2) {
			if (boleto) {
				pI.innerHTML = 'Percebemos que você ainda não realizou o pagamento de seu contrato, aqui estão os dados importantes para o pagamento.';
				p.innerHTML = 'Clique aqui para baixar o seu boleto';
				img.innerHTML = '';
				a.href = boleto;
				button.style.display = 'flex';
			} else {
				p.innerHTML = " "
				pI.innerHTML = " "
				img.innerHTML = '<p class="pModal">Ops, algo deu errado com o seu pagamento, entre em contato com o nosso time ou refaça o contrato.</p>';
				button.style.display = 'none';
			}
		}
	}
}

window.ativaScroll = function(){
	var html = document.getElementById('html');
	html.style.overflow = 'auto';
}
window.semScroll = function(){
	var html = document.getElementById('html');
	html.style.overflow = 'hidden';
}


